module.exports = __webpack_public_path__ + "img/rope_Braid_2.934a0f9d.png";